var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4884E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 4.8c.635 0 1.15.515 1.15 1.15v.367c0 .635-.515 1.15-1.15 1.15l-1.029-.001.001 15.867c0 1.777-1.397 3.234-3.15 3.329l-.183.005H5.556c-1.777 0-3.234-1.398-3.329-3.151l-.005-.183-.001-15.867H1.15C.515 7.467 0 6.953 0 6.317V5.95C0 5.315.515 4.8 1.15 4.8h22.1zM16.767 0c.607 0 1.1.492 1.1 1.1v.333c0 .608-.493 1.1-1.1 1.1h-9c-.608 0-1.1-.492-1.1-1.1V1.1c0-.608.492-1.1 1.1-1.1h9z",
    transform: "translate(-855.000000, -1801.000000) translate(96.000000, 1479.000000) translate(213.000000, 138.000000) translate(522.000000, 38.000000) translate(0.000000, 14.000000) translate(0.000000, 120.000000) translate(24.000000, 12.000000) translate(4.000000, 2.666667)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.44d95ecd.svg";
export { ForwardRef as ReactComponent };